import {Component, EventEmitter, Input, Output} from "@angular/core";
import {ScreenLayoutEditorModel} from "../screen-layout-editor.model";
import {ITEM_TYPE, ScreenLayoutMenuData, TouchItemData} from "../../../screen-layout.data";
import {FUIAlertService} from "@fedeltapointofsale/ui";

/**
 * Touch item commands
 */
@Component({
    selector: "wbo-screen-layout-touch-item-commands",
    templateUrl: "./screen-layout-touch-item-commands.component.html",
    styleUrls: ["./screen-layout-touch-item-commands.component.scss"]
})
export class ScreenLayoutTouchItemCommandsComponent {
    @Input() icon: string;
    @Input() title: string;
    @Input() showAddMenu: boolean = false;
    @Input() menu: ScreenLayoutMenuData;
    @Output() public commandsToggled$: EventEmitter<boolean> = new EventEmitter<boolean>();
    showEdit: boolean;
    editLabel: string;

    private _item: TouchItemData;

    constructor(public model: ScreenLayoutEditorModel,
                private alertService: FUIAlertService) {
    }

    @Input() get item(): TouchItemData {
        return this._item;
    }

    set item(value: TouchItemData) {
        this._item = value;

        if (value) {
            this.showEdit = value.itemType === ITEM_TYPE.EXTRA || value.itemType === ITEM_TYPE.PREP || value.itemType === ITEM_TYPE.SIZE
                || value.itemType === ITEM_TYPE.SELLABLE;

            if (this.showEdit) {
                switch (this._item.itemType) {
                    case ITEM_TYPE.SELLABLE:
                    case ITEM_TYPE.EXTRA:
                        this.editLabel = "editProduct";
                        break;
                    case ITEM_TYPE.SIZE:
                        this.editLabel = "editSize";
                        break;
                    case ITEM_TYPE.PREP:
                        this.editLabel = "editPrep";
                        break;
                }
            }
        }
    }

    call(func: () => void): void {
        if (!this.item) {
            this.alertService.showInformation("wbo.screen-layout.edit.prompt.selectItem.heading",
                "wbo.screen-layout.edit.prompt.selectItem.message").subscribe(() => {
            });
        } else {
            func();
        }
    }

    insertMenu(): void {
        if (!this.menu) {
            this.alertService.showInformation("wbo.screen-layout.edit.prompt.selectMenu.heading",
                "wbo.screen-layout.edit.prompt.selectMenu.message").subscribe(() => {
            });
        } else {
            this.model.insertMenu(this.menu);
        }
    }

    insertBlank(): void {
        this.call(() => this.model.insertBlank(this.item.listIndex));
    }

    insertProductLine(): void {
        this.call(() => this.model.insertProductLine(this.item.listIndex));
    }

    insertCompositeProduct(): void {
        this.call(() => this.model.insertCompositeProduct(this.item.listIndex));
    }

    insertExtra(): void {
        this.call(() => this.model.insertExtra(this.item.listIndex));
    }

    insertPreparationModifier(): void {
        this.call(() => this.model.insertPreparationModifier(this.item.listIndex));
    }

    insertSubMenu(): void {
        this.call(() => this.model.insertSubMenu(this._item.listIndex));
    }

    insertSize(): void {
        this.call(() => this.model.insertSize(this.item.listIndex));
    }

    insertNewProductLine(): void {
        this.call(() => this.model.insertNewProductLine(this.item.listIndex));
    }

    edit(): void {
        this.call(() => this.model.editItem(this.item).then(() => {
        }));
    }

    commandsToggled(toggled: boolean) {
        this.commandsToggled$.emit(toggled);
    }
}
